export const usersHeadcells = [
    {
        key: "firstName",
        label: "usersPage.usersTable.firstName"
    },
    {
        key: "lastName",
        label: "usersPage.usersTable.lastName"
    },
    {
        key: "roleName",
        label: "usersPage.usersTable.role"
    },
    {
        key: "emailAddress",
        label: "usersPage.usersTable.emailAddress"
    },
    {
        key: "areaOfExpertise",
        label: "usersPage.usersTable.areaOfExpertise"
    },
    {
        key: "actions",
        label: "usersPage.usersTable.actions"
    }
]

export const beehivesAlertsConfigHeadcells = [
    {
        key: "field",
        label: "beehiveDetailsPage.tabs.alertsTable.field"
    },
    {
        key: "minValue",
        label: "beehiveDetailsPage.tabs.alertsTable.minValue"
    },
    {
        key: "maxValue",
        label: "beehiveDetailsPage.tabs.alertsTable.maxValue"
    },
    {
        key: "actions",
        label: "usersPage.usersTable.actions"
    }
]

export const areaExpertiseHeadcells = [
    {
        key: "name",
        label: "areasExpertisePage.areaTable.name"
    },
    {
        key: "managerFullname",
        label: "areasExpertisePage.areaTable.manager"
    },
    {
        key: "actions",
        label: "areasExpertisePage.areaTable.actions"
    }
]

export const permissionsHeadcells = [
    {
        key: "name",
        label: "permissionsPage.permissionsTable.name"
    },
    {
        key: "view",
        label: "permissionsPage.permissionsTable.view"
    },
    {
        key: "create",
        label: "permissionsPage.permissionsTable.create"
    },
    {
        key: "edit",
        label: "permissionsPage.permissionsTable.edit"
    },
    {
        key: "delete",
        label: "permissionsPage.permissionsTable.delete"
    },
    {
        key: "download",
        label: "permissionsPage.permissionsTable.download"
    },
    {
        key: "massive_download",
        label: "permissionsPage.permissionsTable.massiveDownload"
    }
]